import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { Currencies } from 'types/types'

interface PayoutPaymentReferenceTransferDestinationLimits {
  LOCAL: { min: number; max: number }
  INTERNATIONAL: { min: number; max: number }
}

interface PayoutPaymentReferenceLimits {
  [Currencies.AED]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.EUR]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.GBP]: PayoutPaymentReferenceTransferDestinationLimits
  [Currencies.USD]: PayoutPaymentReferenceTransferDestinationLimits
  default: PayoutPaymentReferenceTransferDestinationLimits
}

export const PAYOUT_PAYMENT_REFERENCE_LIMITS: PayoutPaymentReferenceLimits = {
  [Currencies.AED]: {
    LOCAL: { min: 5, max: 70 },
    INTERNATIONAL: { min: 5, max: 70 },
  },
  [Currencies.EUR]: {
    LOCAL: { min: 5, max: 70 },
    INTERNATIONAL: { min: 5, max: 70 },
  },
  [Currencies.GBP]: {
    LOCAL: { min: 5, max: 18 },
    INTERNATIONAL: { min: 5, max: 18 },
  },
  [Currencies.USD]: {
    LOCAL: { min: 5, max: 10 },
    INTERNATIONAL: { min: 5, max: 115 },
  },
  default: {
    LOCAL: { min: 5, max: 20 },
    INTERNATIONAL: { min: 5, max: 20 },
  },
}

export const createPaymentReferenceSchema = (
  label: string,
  t: TFunction<'translation', undefined>,
  isRequired = false
) => {
  const schema = yup
    .string()
    .trim()
    .label(label)
    .test({
      test(value, ctx) {
        if (!value && isRequired) {
          return ctx.createError({
            message: t('fieldRequired', { field: t('beneficiaryPaymentReference') }),
          })
        }

        return true
      },
    })

  return schema
}
